import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {BaseService} from '../../../shared/services/base.service';
import {ApiResponse} from '../../../shared/model/api-response';
import {Game} from '../../../shared/model/game';
import {BggBulkImportItem, BggBulkImportResponse, BggGameDto, BggSearchResult} from '../../../shared/model/bgg';

@Injectable({
  providedIn: 'root',
})
export class GameService extends BaseService {

  httpClient: HttpClient = inject(HttpClient);

  constructor() {
    super();
  }

  public getAllGames(): Observable<ApiResponse<Array<Game>>> {
    return this.httpClient.get<ApiResponse<Array<Game>>>(`${this.baseUrl}/games`);
  }

  public getGameById(id: number): Observable<ApiResponse<Game>> {
    return this.httpClient.get<ApiResponse<Game>>(`${this.baseUrl}/games/${id}`);
  }

  public getMyGames(): Observable<ApiResponse<Array<Game>>> {
    return this.httpClient.get<ApiResponse<Array<Game>>>(`${this.baseUrl}/games/search/mine`);
  }

  public searchGames(name: string, mine: boolean): Observable<ApiResponse<Array<Game>>> {
    const params = new HttpParams()
      .set('name', name)
      .set('mine', mine);
    return this.httpClient.get<ApiResponse<Array<Game>>>(`${this.baseUrl}/games/search`, {params});
  }

  public saveGame(game: Game): Observable<ApiResponse<Game>> {
    return this.httpClient.post<ApiResponse<Game>>(`${this.baseUrl}/games`, game);
  }

  public submitGame(game: Game): Observable<ApiResponse<Game>> {
    return this.httpClient.post<ApiResponse<Game>>(`${this.baseUrl}/games/submit`, game);
  }

  public updateGame(game: Game): Observable<ApiResponse<Game>> {
    return this.httpClient.patch<ApiResponse<Game>>(`${this.baseUrl}/games/update`, game);
  }

  public deleteGame(gameId: number): Observable<ApiResponse<string>> {
    return this.httpClient.delete<ApiResponse<string>>(`${this.baseUrl}/games/${gameId}`);
  }

  public searchBggGames(gameName: string, source: string = 'bgg'): Observable<ApiResponse<Array<BggSearchResult>>> {
      const params = new HttpParams().set('gameName', gameName).set('source', source);
    return this.httpClient.get<ApiResponse<Array<BggSearchResult>>>(`${this.baseUrl}/bgg/search`, {params});
  }

  public importBggGamesBulk(games: Array<BggBulkImportItem>): Observable<ApiResponse<BggBulkImportResponse>> {
    return this.httpClient.post<ApiResponse<BggBulkImportResponse>>(`${this.baseUrl}/bgg/import/bulk`, {games});
  }

  public getBggGameDetails(id: number, source: string = 'bgg'): Observable<ApiResponse<BggGameDto>> {
      const params = new HttpParams().set('source', source);
      return this.httpClient.get<ApiResponse<BggGameDto>>(`${this.baseUrl}/bgg/${id}`, {params});
    }

}
